import { create } from 'zustand';

export type ReleaseMomentKind = 'sent' | 'released';

interface ReleaseMomentEntry {
  token: number;
  kind: ReleaseMomentKind;
  quantity: number;
  plainToast: boolean;
}

interface ReleaseMomentState {
  entry: ReleaseMomentEntry | null;
  show: (kind: ReleaseMomentKind, quantity: number, plainToast: boolean) => void;
  dismiss: () => void;
}

let token = 0;

/** A moment belongs only to the person who completed the action in this tab. */
export const useReleaseMomentStore = create<ReleaseMomentState>((set) => ({
  entry: null,
  show: (kind, quantity, plainToast) => {
    if (quantity > 0) set({ entry: { token: ++token, kind, quantity, plainToast } });
  },
  dismiss: () => set({ entry: null }),
}));

export const announceReleaseMoment = (kind: ReleaseMomentKind, quantity = 1, plainToast = true): void => {
  useReleaseMomentStore.getState().show(kind, quantity, plainToast);
};
